/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';
import React from 'react';
import { Skeleton } from 'antd';

export default function LoadingNotificationId() {
  return (
    <div className="relative !z-0 h-screen">
    <div style={{"display":"flex","paddingTop":"0px","paddingRight":"0px","paddingBottom":"0px","paddingLeft":"0px","width":"100%","height":"100vh","flexDirection":"column"}}>
      <div style={{"display":"flex","flexDirection":"row","paddingTop":"20px","paddingLeft":"38px","paddingRight":"38px","paddingBottom":"20px","height":"100px","justifyContent":"space-between","backgroundColor":"#ffffff","alignItems":"center"}}>
        <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","gap":"16px","alignItems":"center"}}>
          <Skeleton.Button active={true} />
          <Skeleton.Button active={true} rootClassName="!text-[28px] !bg-[undefined] !border-[undefined] !text-[undefined]" />
        </div>
        <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","alignItems":"center","gap":"16px"}} />
      </div>
      <div style={{"display":"flex","flexDirection":"column","paddingTop":"16px","paddingLeft":"38px","paddingRight":"38px","paddingBottom":"16px","flex":"1","gridColumn":"undefined","gridRow":"undefined","justifyContent":"undefined","alignItems":"undefined","gap":"16px","gridTemplateColumns":"undefined","gridTemplateRows":"undefined","width":"undefined","height":"undefined","marginTop":"undefined","marginLeft":"undefined","marginRight":"undefined","marginBottom":"undefined","backgroundColor":"#f5f7fa","border":"undefined","borderRadius":"undefined","top":"undefined","left":"undefined","position":"undefined","right":"undefined","bottom":"undefined","fontSize":"undefined","color":"undefined","fontWeight":"undefined","fontStyle":"undefined","opacity":"undefined","objectFit":"undefined","overflow":"auto"}}>
        <div style={{"display":"flex","flexDirection":"column","paddingTop":"32px","paddingLeft":"32px","paddingRight":"32px","paddingBottom":"32px","backgroundColor":"#ffffff","borderRadius":"25px","gap":"16px"}}>
          <Skeleton.Input active={true} rootClassName="!pt-[5px] !pl-[5px] !pr-[5px] !pb-[5px] !flex !flex-col">
            <div style={{"display":"grid","flexDirection":"row","paddingTop":"0px","paddingLeft":"0px","paddingRight":"0px","paddingBottom":"0px","gap":"32px","gridTemplateColumns":"repeat(2, minmax(0, 1fr))"}}>
              <Skeleton.Input active={true}>
                <Skeleton.Input active={true} />
              </Skeleton.Input>
              <Skeleton.Input active={true}>
                <Skeleton.Input active={true} />
              </Skeleton.Input>
            </div>
            <div style={{"display":"grid","flexDirection":"row","paddingTop":"0px","paddingLeft":"0px","paddingRight":"0px","paddingBottom":"0px","gap":"32px","gridTemplateColumns":"repeat(2, minmax(0, 1fr))"}}>
              <Skeleton.Input active={true}>
                <Skeleton.Input active={true} />
              </Skeleton.Input>
              <Skeleton.Input active={true}>
                <Skeleton.Input active={true} />
              </Skeleton.Input>
            </div>
            <div style={{"display":"grid","flexDirection":"row","paddingTop":"0px","paddingLeft":"0px","paddingRight":"0px","paddingBottom":"0px","gap":"32px","gridTemplateColumns":"repeat(2, minmax(0, 1fr))"}}>
              <Skeleton.Input active={true}>
                <Skeleton.Input active={true} />
              </Skeleton.Input>
            </div>
            <div style={{"display":"flex","flexDirection":"column","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","gap":"16px"}}>
              <Skeleton.Button active={true} rootClassName="!text-[16px]" />
              <div style={{"display":"grid","flexDirection":"row","paddingTop":"0px","paddingLeft":"0px","paddingRight":"0px","paddingBottom":"0px","gap":"32px","gridTemplateColumns":"repeat(2, minmax(0, 1fr))"}}>
                <div style={{"padding":"5px","display":"block"}}>
                  <Skeleton.Input active={true}>
                    <Skeleton.Input active={true} />
                  </Skeleton.Input>
                </div>
                <div style={{"padding":"5px","display":"block"}}>
                  <Skeleton.Input active={true}>
                    <Skeleton.Input active={true} />
                  </Skeleton.Input>
                </div>
              </div>
              <div style={{"display":"grid","flexDirection":"row","paddingTop":"0px","paddingLeft":"0px","paddingRight":"0px","paddingBottom":"0px","gap":"32px","gridTemplateColumns":"repeat(2, minmax(0, 1fr))","marginTop":"0px"}}>
                <div style={{"padding":"5px","display":"block"}}>
                  <Skeleton.Input active={true}>
                    <Skeleton.Input active={true} />
                  </Skeleton.Input>
                </div>
                <div style={{"padding":"5px","display":"block"}}>
                  <Skeleton.Input active={true}>
                    <Skeleton.Input active={true} />
                  </Skeleton.Input>
                </div>
              </div>
            </div>
            <Skeleton.Input active={true} block={true} rootClassName="!bg-[#f5f7fa] !text-[#718ebf] !h-[240px] !rounded-[25px] !pt-[32px] !pl-[32px] !pr-[32px] !pb-[32px] !mt-[16px]" />
            <div style={{"display":"flex","flexDirection":"row","paddingTop":"0px","paddingLeft":"0px","paddingRight":"0px","paddingBottom":"0px","justifyContent":"flex-end","alignItems":"center","gap":"16px"}}>
              <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px","alignItems":"center","gap":"8px"}}>
                <Skeleton.Button active={true} />
                <Skeleton.Input active={true} />
                <div style={{"padding":"10px","display":"block"}}>
                  <Skeleton.Input active={true} />
                </div>
              </div>
              <Skeleton.Button active={true} />
            </div>
          </Skeleton.Input>
        </div>
      </div>
    </div>
    </div>
  );
}
